import { withSvgProps } from './helpers'
import { ReactComponent as SvgComponent } from './svg/google-trust-stars.svg'

type SvgProps = React.ComponentProps<typeof SvgComponent>

const Svg: React.FC<SvgProps> = (props) => <SvgComponent {...props} />

export const GoogleTrustStars = withSvgProps(Svg)
